




















import { Vue, Prop, Component } from 'vue-property-decorator';
import PromptBar from '@lib-shared/prompt-bar/PromptBar.vue';
@Component({
  components: {
    PromptBar,
  },
})
export default class RevisionPromptBar extends Vue {
  @Prop() timeLeft: number;
  @Prop() sender: string;
}
